import React, { MutableRefObject } from "react";
import Space from "antd/lib/space";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Checkbox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import Form, { RuleObject } from "antd/lib/form";
import styled from "styled-components";

import { AppCard } from "components/card";
import { Colors } from "helpers/colors";
import { SurveyInput } from "pages/symptoms/surveyForms/surveyInput";
import { Platform } from "constants/roles";
interface PainSectionProps {
  readonly currentPage: number;
  setOtherPainTempInput(input: string): void;
  readonly otherPainTempInput: string;
  readonly otherPainInputRef: MutableRefObject<string>;
}

export const PainSection: React.FC<PainSectionProps> = ({
  currentPage,
  otherPainInputRef,
  otherPainTempInput,
  setOtherPainTempInput
}) => {
  const params = new URLSearchParams(window.location.search);
  const platform = params.get("platform");
  const validateWhereIsYourPain = (
    rules: RuleObject,
    value: string,
    callback: (error?: string) => void
  ) => {
    if (
      otherPainInputRef.current === "" &&
      localStorage.getItem("whereIsYourPain")?.includes("Other")
    ) {
      callback("Please enter value for 'Other' field.");
    } else {
      callback();
    }
  };

  return (
    <>
      {currentPage === 5 && (
        <Space direction="vertical" size={20}>
          <Space direction="vertical" size={20}>
            <AppCard
              cardHeight="fit-content"
              cardWidth={
                platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
              }
            >
              <Space
                direction="vertical"
                size={20}
                style={{ width: "100%", padding: "10px" }}
              >
                <DisclaimerTitle>PAIN</DisclaimerTitle>
                <CardTitle>
                  Have you had any pain?
                  <AsteriskStyle> *</AsteriskStyle>
                </CardTitle>
                <FormItemStyle
                  name="Have you had any pain"
                  label=""
                  rules={[
                    {
                      required: true
                    }
                  ]}
                  initialValue={""}
                >
                  <Radio.Group
                    value={localStorage.getItem("hadAnyPain")}
                    onChange={e =>
                      localStorage.setItem("hadAnyPain", e.target.value)
                    }
                  >
                    <Space direction="vertical">
                      <Radio value={"Yes"}>Yes</Radio>
                      <Radio value={"No"}>No</Radio>
                    </Space>
                  </Radio.Group>
                </FormItemStyle>
              </Space>
            </AppCard>
          </Space>
        </Space>
      )}
      {currentPage === 6 && (
        <Space direction="vertical" size={20}>
          <AppCard
            cardHeight="fit-content"
            cardWidth={
              platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
            }
          >
            <Space
              direction="vertical"
              size={20}
              style={{ width: "100%", padding: "10px" }}
            >
              <DisclaimerTitle>PAIN</DisclaimerTitle>
              ** PLEASE BE SURE TO CALL YOUR DOCTOR OR SEEK EMERGENCY CARE IF
              YOU ARE REPORTING ANY SYMPTOMS BELOW **
            </Space>
          </AppCard>
          <AppCard
            cardHeight="fit-content"
            cardWidth={
              platform === Platform.MOBILE ? "calc(100vw - 60px)" : "640px"
            }
          >
            <Space
              direction="vertical"
              size={20}
              style={{ width: "100%", padding: "10px" }}
            >
              <CardTitle>
                Where is your pain?<AsteriskStyle> *</AsteriskStyle>
              </CardTitle>

              <FormItemStyle
                name="Where is your pain"
                label=""
                initialValue={""}
                rules={[
                  {
                    required: true
                  },
                  {
                    validator: validateWhereIsYourPain,
                    validateTrigger: "submit"
                  }
                ]}
              >
                <Checkbox.Group
                  style={{ width: "100%" }}
                  onChange={e =>
                    localStorage.setItem("whereIsYourPain", e.toString())
                  }
                  value={localStorage.getItem("whereIsYourPain")?.split(/,/)}
                >
                  <Row gutter={[10, 10]}>
                    <Col span={24}>
                      <Checkbox value="Over either flank (either side of your back, below your rib cage)">
                        Over either flank (either side of your back, below your
                        rib cage)
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Low back pain">Low back pain</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Groin pain">Groin pain</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Abdominal pain">Abdominal pain</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Other">Other</Checkbox>
                      <SurveyInput
                        value={otherPainTempInput ?? otherPainInputRef}
                        placeholder={""}
                        onChange={e => {
                          setOtherPainTempInput(e.target.value);
                          otherPainInputRef.current = e.target.value;
                        }}
                        style={{ width: "70%", marginLeft: "30px" }}
                      />
                    </Col>
                  </Row>
                </Checkbox.Group>
              </FormItemStyle>
            </Space>
          </AppCard>
        </Space>
      )}
    </>
  );
};

const DisclaimerTitle = styled.div`
  width: 100%;
  padding: 8px 8px 8px 20px;
  margin-left: -25px;
  background: ${Colors.DodgerBlue};
  font-size: 18px;
  font-family: sans-serif;
  border-radius: 8px 8px 0px 0px;
  color: white;
  position: absolute;
  top: 0;
`;

const FormItemStyle = styled(Form.Item)`
  margin-bottom: 0px;
`;

const AsteriskStyle = styled.span`
  font-weight: 800;
  color: red;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-family: sans-serif;
`;
